window.emarsysRecoCallbackHandler = function emarsysRecoCallbackHandler(SC) {
window.useStore().commit('blue/SET_RECOS', SC.page.products);
};